import clsx from 'clsx'
import PropTypes from 'prop-types'

const Tags = ({
  dataTestId = 'tag',
  label,
  prefixIcon,
  backgroundColor,
  fontColor,
  tagClassName,
}) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-center box-border w-fit p-1 whitespace-pre-wrap rounded-2xl z-0',
        tagClassName
      )}
      style={{ backgroundColor, color: fontColor }}
      data-testid={dataTestId}
    >
      {prefixIcon && (
        <div className="flex items-center justify-center w-4 h-4" data-testid="tag-icon">
          {prefixIcon}
        </div>
      )}
      <div className="type-micro-heavy mx-1">{label}</div>
    </div>
  )
}

Tags.propTypes = {
  dataTestId: PropTypes.string,
  label: PropTypes.string.isRequired,
  prefixIcon: PropTypes.node,
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  tagClassName: PropTypes.string,
}

export default Tags
